import React, { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { Box, Button, CircularProgress } from "@mui/material";
import Login from "./login";
import TermsAndConditions from "./TermsAndConditions";
import VerificationCode from "./VerificationCode";
import { loginRequestCaps } from "../authConfig";
import { useMsal } from "@azure/msal-react";
import { InteractionStatus } from "@azure/msal-browser";
import gmlogo from './GMEnergy.png';
import './styles.css';
import * as constants from '../utils/constants.ts';

const getApiEndpoint = () => {
  const { host } = window.location;
  if (host.includes('prod')) return constants.API_ENDPOINT_PROD;
  return constants.API_ENDPOINT_DEV;
};
const API_ENDPOINT = getApiEndpoint();

const MainPage = () => {
  const [savedSerialNumber, setSavedSerialNumber] = useState(-1);
  const [showLogin, setShowLogin] = useState(true);
  const [showTerms, setShowTerms] = useState(false);
  const [showVerification, setShowVerification] = useState(false);
  const [token, setToken] = useState(null);
  const [errorOccurred, setErrorOccurred] = useState(false);
  const { instance, accounts, inProgress } = useMsal();
  // const [anchorEl, setAnchorEl] = useState(null);
  const [passcode, setPasscode] = useState("");
  const [isLoggingIn, setIsLoggingIn] = useState(false);

  const reacquireToken = useCallback(() => {
    // console.log('has account');
    const request = {
      scopes: ['openid'],
      account: instance.getAllAccounts()[0],
    };

    instance
      .acquireTokenSilent(request)
      .then((tokenResponse) => {
        setToken(tokenResponse.idToken)
        setShowLogin(false);
        setShowTerms(true);
      })
      .catch((error) => {
        console.log('error', error);
        // handle other errors
      });
  }, [instance]);

  // MsalProvider handles initialize() and handleRedirectPromise() for us.
  // We wait until no interaction is in progress, then read the resulting
  // account state. After a redirect login the account is cached, so we can
  // silently acquire the token; otherwise we show the login screen.
  useEffect(() => {
    if (inProgress !== InteractionStatus.None) {
      return;
    }
    if (accounts.length > 0) {
      reacquireToken();
    } else {
      setShowLogin(true);
      setShowTerms(false);
    }
  }, [inProgress, accounts, reacquireToken]);

  const setTnCAndSerialNumber = useCallback(async (sn) => {
    // console.log(token)
    const config = {

      headers: {
        // locale: `en-US`,
        caps_auth: token,
        "Content-Type": "application/json",
      }
    };
    const data = {
      serialNumber: sn,
    };
    try {
      const response = await axios.post(
        API_ENDPOINT,
        data,
        config
      );
      if (response.status === 200) {
        setPasscode("Thank you for registering your product. If you have any questions, please contact 1-833-64POWER.");
        setErrorOccurred(false);
      }
      // const passcode = response.data.Passcode;
      // setPasscode(passcode);
    } catch (error) {
      setErrorOccurred(true);
      if (error.response?.data?.field === "Token has expired") {
        instance.logoutRedirect({ postLogoutRedirectUri: "/" });
      }
    }
  }, [token, instance]);

  const handleSignIn = () => {
    if (inProgress !== InteractionStatus.None) {
      return;
    }
    setIsLoggingIn(true);
    instance.loginRedirect(loginRequestCaps).catch((error) => {
      console.error('loginRedirect failed', error);
      setIsLoggingIn(false);
    });
  };

  const handleSignOut = () => {
    // sessionStorage.removeItem('gmLogin');
    // setAnchorEl(null);
    instance.logoutRedirect({
      // postLogoutRedirectUri: '/logged-out',
      postLogoutRedirectUri: "/",
    });
  };
  const handleLogin = () => {
    handleSignIn();
  };

  // let tncValue = false;
  const handleTermsAccept = (serialNumber) => {
    setShowTerms(false);
    setShowVerification(true);
    // let tncValue = true;
    //send order number
    setTnCAndSerialNumber(serialNumber);
    setSavedSerialNumber(serialNumber);

  };
  const handleRetry = () => {
    setTnCAndSerialNumber(savedSerialNumber);
  };
  // let orderNumberValue = "123456";
  const handleVerification = () => {
    setShowVerification(false);
    // let orderNumberValue = "'654321'";
  };
  // console.log(anchorEl);
  const isPostLoginLoading =
    inProgress !== InteractionStatus.None ||
    (accounts.length > 0 && showLogin);

  return (
    <Box
      sx={{
        backgroundColor: '#2e2d31',
        minHeight: '100vh',
        position: 'relative',
        overflow: 'auto',
        overflowX: 'hidden',
        // '@media (max-width: 325px)': {
        //   minHeight: '160vh',
        // },
      }}>
      {isPostLoginLoading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
          <CircularProgress color="primary" />
        </Box>
      ) : (
      <div className="page-container">
        <div className="pages">
      {showLogin && <Login onLogin={handleLogin} loading={isLoggingIn} />}
      {showTerms && <TermsAndConditions onAccept={handleTermsAccept} />}
      {showVerification && <VerificationCode onRetry={handleRetry} onSuccess={handleVerification} passcode={passcode} />}
      </div>
      {errorOccurred && showVerification &&
      // <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: 'calc(90% - 110px)', zIndex: '10000' }}>
      <div className="retry" style={{maxWidth: '500px'}}>
        <div style={{paddingBottom: '10px', fontSize: '14px', fontWeight: 'normal', color: 'red' }}>An error occurred. Click below to retry</div>
        <div style={{paddingBottom: '20px', fontSize: '14px', fontWeight: 'normal', color: 'red' }}>If you continue to get this error, please call the GM Energy Customer Support Center at <span style={{whiteSpace: 'nowrap'}}>1-833-64POWER</span></div>
        <Button variant="contained" color="primary" size="small" style={{ fontSize: '12px' }} onClick={handleRetry}>Retry</Button>
      </div>
      }
      </div>
      )}
      {token && (
        <Button
          variant="contained"
          color="primary"
          onClick={handleSignOut}
          sx={{
            position: 'absolute',
            top: '50px',
            right: '50px',
            zIndex: '1',
            '@media (max-width: 325px)': {
              top: '100px',
              left: '50px',
              width: '125px',
            },
          }}>
          Logout
        </Button>
      )}
      <img 
        src={gmlogo} 
        alt="GM Energy logo" 
        style={{
          position: 'absolute',
          top: '45px',
          height: '50px',
          left: '50px',
          zIndex: '0',
          filter: 'brightness(0) invert(1)',
          }} />
    </Box>
  );
};

export default MainPage;
